import React from 'react';
import { useTest } from '../hooks';
import { LoadingScreen, QuestionScreen } from '../components/test';

const TestPage: React.FC = () => {
  const {
    question,
    selectedAnswer,
    loading,
    currentIndex,
    totalQuestions,
    canGoBack,
    timeRemaining,
    setSelectedAnswer,
    handleSubmit,
    handleNavigate,
    handleQuit,
    loadNextQuestion,
  } = useTest();

  if (loading || !question) return <LoadingScreen />;

  return (
    <QuestionScreen
      question={question}
      selectedAnswer={selectedAnswer}
      loading={loading}
      canGoBack={canGoBack}
      timeRemaining={timeRemaining}
      currentIndex={currentIndex}
      totalQuestions={totalQuestions}
      onAnswerSelect={setSelectedAnswer}
      onSubmit={handleSubmit}
      onNavigate={handleNavigate}
      onQuit={handleQuit}
      onTimeExpired={loadNextQuestion}
    />
  );
};

export default TestPage;
